import { TITLE_KEY } from '@esentai/core/features/benefits/consts/keys';
import { annotations } from '@esentai/core/features/benefits/serializer';
import { ascending } from '@esentai/core/query-dsl';
import { sort, string } from '@esentai/core/serializers/params';

import { createPageSerializer, getLinkCreator } from '@/serializers';

import { ROUTE_PATH } from './consts';

const serializer = createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: ascending(TITLE_KEY),
  }),
  include: string({
    // defaultValue: 'location',
  }),
});

export const createLink = getLinkCreator(ROUTE_PATH, serializer);

export default serializer;
